import React from 'react'
import PropTypes from 'prop-types'
import Dialog from 'material-ui/Dialog'

const ModalAlert = props => (
  <Dialog
    title={props.title}
    open={props.isOpen}
    onRequestClose={props.onClose}
  >
    <div>
      {props.message}
    </div>
  </Dialog>
)

ModalAlert.propTypes = {
  title: PropTypes.string.isRequired,
  isOpen: PropTypes.bool.isRequired,
  message: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
}

export default ModalAlert
